import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import DashboardTables from './DashboardTables'
import Spin from 'antd/lib/spin';
import Alert from 'antd/lib/alert';


@translate()
export default class AdminDashboard extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        reportData: PropTypes.object
    };

    render() {
        const {
            reportData,
            t,
        } = this.props;
        const dashboardError = reportData && (reportData.dashboardError || !reportData.approvedLoans || !reportData.creditorsAccountBalance);

        return (
            <div>
                <h1 className="dashboard-header">{t('Business dashboard Maják')}</h1>


                {!reportData ?
                    <Spin className="dasboard-spinner" spinning={!reportData}>
                        <div className="dashboard-spinner-message">{t("Prebieha výpočet dát pre dashboard")}</div>

                    </Spin> : dashboardError ?

                    <Alert
                        message={t('Dashboard failed to load')}
                        description={reportData.dashboardError || t('Dashboard returned incomplete data')}
                        type="error"
                        showIcon
                    /> :

                    <DashboardTables t={t} reportData={reportData}></DashboardTables>}


            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/features/admin-dashboard/components/AdminDashboard.js